export default "__VITE_ASSET__jB_aTjdQ__"